<template>
  <div>
    <Header></Header>
    <div>
      <!-- Postulate or share -->
      <div class="postulate-job my-0 py-5 py-md-10 elevation-10 ">
        <v-container v-if="offer.status === 'open' && dateAvailable">
          <v-row justify="center">
            <v-col cols="12" sm="2" md="3" class="text-center" align-self="center">
              <h3>Postula o Comparte esta oferta</h3>
            </v-col>
            <v-col cols="12" sm="7" md="6" class="text-md-left text-center" align-self="center">
              <v-btn
                class="mx-2 mx-sm-5"
                :href="shareUrl.facebook"
                target="_blank"
                icon
                text
              >
                <v-icon large color="info">mdi-facebook</v-icon>
              </v-btn>
              <v-btn
                class="mx-2 mx-sm-5"
                :href="shareUrl.twitter"
                target="_blank"
                icon
                text
              >
                <v-icon large color="info">mdi-twitter</v-icon>
              </v-btn>
              <v-btn
                class="mx-2 mx-sm-5"
                :href="shareUrl.whatsapp"
                target="_blank"
                icon
                text
              >
                <v-icon large color="info">mdi-whatsapp</v-icon>
              </v-btn>
              <!-- <v-btn @click="share('linkedin')" icon text class="mx-2 mx-sm-5"><v-icon large color="info">mdi-linkedin</v-icon></v-btn> -->
              <v-btn
                class="mx-2 mx-sm-5"
                :href="shareUrl.linkedin"
                target="_blank"
                icon
                text
              >
              <v-icon large color="info">mdi-linkedin</v-icon>
              </v-btn>
              <!-- <v-btn @click="share('linkedin')" icon text class="mx-2 mx-sm-5"><v-icon large color="info">mdi-linkedin</v-icon></v-btn> -->
              <v-btn
                class="mx-2 mx-sm-5"
                :href="shareUrl.linkedin"
                target="_blank"
                icon
                text
              >
                <v-icon large color="info">mdi-email</v-icon>
              </v-btn>
              <v-btn
                class="mx-2 mx-sm-5"
                icon
                text
                @click="onCopySocial"
              >
                <v-icon large color="info">mdi-content-copy</v-icon>
              </v-btn>
              <v-snackbar
                v-model="snackbar.model"
                timeout="25000"
                centered
                rounded="xl"
                top
                content-class="snackbar__text"
                class="snackbar__text"
              >
                {{ snackbar.text }}
                <template v-slot:action="{ attrs }">
                  <v-btn
                    v-bind="attrs"
                    :color="snackbar.color"
                    text
                    @click="snackbar.model = false"
                  >
                    <div>OK</div>
                  </v-btn>
                </template>
              </v-snackbar>
            </v-col>
            <v-col cols="10" sm="10" md="3" class="text-center" align-self="center">
              <v-btn
                x-large block color="info"
                class="btn-postular"
                :to="redirectPath"
                :disabled="type === 'organization'"
              >
                POSTULAR
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="offer.status === 'close' || !dateAvailable && offer.status !== 'disable'">
          <v-row justify="center">
            <v-col cols="12" sm="10" md="9" class="text-center" align-self="center">
              <h3>La oferta está finalizada, te invitamos a revisar otras ofertas </h3>
            </v-col>
            <v-col cols="10" sm="10" md="3" class="text-center" align-self="center">
              <v-btn
                x-large
                block
                color="info"
                class="btn-postular"
                to="/offers"
              >
                VER OFERTAS ACTIVAS
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="offer.status === 'disable'">
          <v-row justify="center">
            <v-col cols="12" sm="10" md="10" class="text-center">
              <h3>Esta oferta se encuentra temporalmente inactiva. La organización ha decidido pausarla y no recibir más postulaciones por el momento. <br>¡Manténte atento porque esto podría cambiar hasta la fecha del cierre de postulaciones!</h3>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- Hero section -->
      <section id="hero-postulate-job">
        <v-parallax src="@/assets/images/back-single-oferta.webp">
          <v-container>
            <v-row justify="center">
              <v-col cols="11" sm="10" md="11" lg="9" class="text-left pa-0">
                <v-row class="px-2" align="center">
                  <v-col cols="12" md="12" class="pa-0 mb-3 d-flex align-center">
                    <v-avatar class="ma-0 float-left avatar-offer" >
                      <v-btn v-if="offer.alias === null || offer.alias === ''" small icon class="ma-0 pa-0 float-left txt-job" color="white" :to="{name: 'OrganizationHome', params:{slug: offer.organization.slug}}"><v-img :src="getLogo(offer)" > </v-img></v-btn>
                      <v-btn v-else small icon class="ma-0 pa-0 float-left txt-job" color="white" :to="`/offer/${offer.slug}`"><v-img :src="getLogo(offer)" > </v-img></v-btn>
                    </v-avatar>
                    <v-btn v-if="offer.alias === null || offer.alias === ''" small text class="float-left txt-job" color="white" :to="{name: 'OrganizationHome', params:{slug: offer.organization.slug}}">{{ offer.organization.name }}</v-btn>
                    <v-btn v-else small text class="float-left txt-job mt-10" color="white" :to="`/offer/${offer.slug}`">{{ offer.organization.name }}</v-btn>
                  </v-col>
                </v-row>
                <v-row class="pa-0">
                  <v-col cols="12" sm="10" md="10" lg="10" class="px-3 py-1">
                    <h1>{{ offer.title }}</h1>
                  </v-col>
                </v-row>
                <v-row class="pa-0">
                  <v-col cols="12">
                    <v-icon class="float-left mr-3 d-none d-sm-block" color="white">mdi-send</v-icon>
                    <p class="d-inline-block"><span class="title-txt-job">Postulaciones:</span> {{ getStartDate }} - {{ getEndDate }}</p>
                  </v-col>
                </v-row>
                <v-row class="pa-0">
                  <v-col cols="12" class="px-2 py-0">
                    <p class="d-block py-1"><span class="title-txt-job">Profesiones sugeridas:</span> {{ professions }}</p>
                    <p class="d-block py-1"><span class="title-txt-job">Áreas de conocimiento:</span> {{ areas }}</p>
                    <p class="d-block py-1" v-if="offer.experience.length"><span class="title-txt-job">Experiencia:</span> {{offer.experience[0]}} a {{offer.experience[1] > 30 ? "30+" : offer.experience[1] }} Años</p>
                    <p class="d-block py-1" v-if="!offer.salary.hidden">
                        <span class="title-txt-job">Renta:</span> 
                        {{ offer.salary.currency }} 
                        {{ offer.salary.range[0] != 0 ? formatter(offer.salary.range[0]) + ' a ' + offer.salary.currency + ' ' + formatter(offer.salary.range[1]) : formatter(offer.salary.range[1]) }}
                    </p>

                  </v-col>
                </v-row>
                <v-row class="px-0 pt-6">
                  <v-col cols="12" class="pa-0">
                    <div class="ma-1 pa-0 d-inline-block" v-for="(benefit, i) in offer.benefits" :key="i">
                      <img class="ma-0 pa-0 d-inline-block ico-benefits" :src="getBenefits(benefit)" />
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section>
      <div id="job-detail">
        <v-container>
          <v-row justify="center">
            <v-col cols="8" sm="3" md="3" lg="2" class="mx-md-0 mx-lg-10">
              <v-card height="180">
                <v-container>
                  <v-row align-content="center">
                    <v-col cols="12" class="py-1 text-center">
                      <v-icon>mdi-map-marker-outline</v-icon>
                        <h3>Lugar</h3>
                      <p>{{offer.city}}</p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
            <v-col cols="8" sm="3" md="3" lg="2" class="mx-md-0 mx-lg-10">
              <v-card height="180">
                <v-container>
                  <v-row align-content="center">
                    <v-col cols="12" class="py-1 text-center">
                      <v-icon>mdi-clock-time-four-outline</v-icon>
                      <h3>Jornada</h3>
                      <p>{{offer.workingDay}}</p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
            <v-col cols="8" sm="3" md="3" lg="2" class="mx-md-0 mx-lg-10">
              <v-card height="180">
                <v-container>
                  <v-row align-content="center">
                    <v-col cols="12" class="py-1 text-center">
                      <v-icon>mdi-office-building-marker-outline</v-icon>
                      <h3>Modalidad</h3>
                      <p>{{offer.workingMode}}</p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
            <v-col cols="8" sm="3" md="3" lg="2" class="mx-md-0 mx-lg-10">
              <v-card height="180">
                <v-container>
                  <v-row align-content="center">
                    <v-col cols="12" class="py-1 text-center">
                      <div class="px-10 px-sm-6 px-md-10 px-lg-8 py-0 text-center">
                        <v-avatar class="icon-goals" tile v-for="goal in goalsToShow" :key="goal">
                          <v-tooltip top class="ma-0 my-0">
                            <template v-slot:activator="{ on, attrs }">
                              <img v-bind="attrs" v-on="on" class="" :src="getGoals(goal).img"/>
                            </template>
                            <span>{{ getGoals(goal).name }}</span>
                          </v-tooltip>
                        </v-avatar>
                      </div>
                      <h3 class="text-center my-4">Propósitos</h3>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- Content -->
      <section class="content-job offer-content">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" sm="11" md="11" lg="8">
              <!-- Propósito -->
              <v-row class="py-3" justify="center">
                <v-col cols="11" sm="12" class="pa-0">
                  <img src="@/assets/images/ico-purpose.webp" class="ico-purpose d-none d-sm-block" />
                  <h2>Propósito del cargo</h2>
                </v-col>
                <v-col cols="11" sm="12" class="pa-1">
                  <div v-html="offer.purpose"></div>
                </v-col>
              </v-row>

              <!-- Descripción -->
              <v-row class="offer-content__description py-3" justify="center">
                <v-col cols="11" sm="12" class="pa-0">
                  <img src="@/assets/images/ico-description.webp" class="ico-purpose d-none d-sm-block" />
                  <h2>Descripción</h2>
                </v-col>
                <v-col cols="11" sm="12" class="pa-1">
                  <div v-html="offer.description"></div>
                </v-col>
              </v-row>

              <!-- Perfil buscado -->
              <v-row class="py-3" justify="center">
                <v-col cols="11" sm="12" class="pa-0">
                  <img src="@/assets/images/ico-profile.webp" class="ico-purpose d-none d-sm-block" />
                  <h2>Perfil buscado</h2>
                </v-col>
                <v-col cols="11" sm="12" class="pa-1">
                  <div v-html="offer.requirements"></div>
                </v-col>
              </v-row>

              <!-- Requisitos deseables -->
              <v-row class="py-3" justify="center">
                <v-col cols="11" sm="12" class="pa-0">
                  <img src="@/assets/images/ico-points.webp" class="ico-purpose d-none d-sm-block" />
                  <h2>Características que suman puntos</h2>
                </v-col>
                <v-col cols="11" sm="12" class="pa-1">
                  <div v-html="offer.optionals"></div>
                </v-col>
              </v-row>

              <!-- Fecha de incorporación -->
              <v-row class="py-3" justify="center">
                <v-col cols="11" sm="12" class="pa-0">
                  <img src="@/assets/images/ico-date.webp" class="ico-purpose d-none d-sm-block" />
                  <h2 class="title-date">Fecha estimada de incorporación al cargo</h2>
                </v-col>
                <v-col cols="11" sm="12" class="pa-1">
                  <div v-html="getStartToWorkDay"></div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="10" md="10" lg="8">
              <v-card
                v-if="offer.alias === null || offer.alias === ''"
                class="mt-12 mb-3 card-offer-company"
                :to="{name: 'OrganizationHome', params:{slug: offer.organization.slug}}"
              >
                <v-row justify="center">
                  <v-col cols="2" sm="2" md="2" class="py-0 d-none d-sm-block">
                    <v-list-item-avatar size="90" color="white" class="ma-0 pa-0">
                      <v-img style="background-color: #FFFFF !important;" contain max-width="65" max-height="90" :src="getLogo(offer)"></v-img>
                    </v-list-item-avatar>
                  </v-col>
                  <v-col cols="12" sm="10" md="10" class="px-3 py-0">
                    <v-list-item-content class="d-flex justify-start">
                      <v-list-item-title class="title-card d-flex">
                        {{ offer.organization.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="sub-title-card d-flex">
                        <v-btn
                          class="ma-0 pa-0"
                          color="white"
                          :to="{ name: 'OrganizationHome', params: { slug: offer.organization.slug } }"
                          small
                          text
                        >
                          Ver perfil de la empresa
                        </v-btn>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </div>
    <!-- <OffersList title="Ofertas Relacionadas" count="4"/> -->
    <FAQ />
  </div>
</template>

<script>
import FAQ from "@/components/FAQ";
import { currentImg, meta, handleTxt } from "@/libs/mixins";

/// TODO TO HELPERS !!!
function pad(n, l) {
    var str = "";
    for (let len = 0; len < (l - String(n).length); len++) {
        str += "0";
    }
    str += n;
    return str;
}

export default {
    name: "OfferShow",

    components: { FAQ },

    props: ["slug", "offer"],

    mixins: [currentImg, meta, handleTxt],

    metaInfo() {
        return this.getMetaInfo({
            title: `${ this.offer.title } - ${ this.offer.organization.name }`,
            description: `Propósito: ${ this.getInnerText(this.offer.purpose) }` 
        });
    }, 

    data() {
        return {
            type: "candidate",
            goalsToShow: [],
            snackbar: {
                text: "",
                model: "",
                color: "success",
            },
        };
    },

    computed: {
        areas() {
            return this.offer.areas.join(", ");
        },
        redirectPath() {
            let { offer, slug } = this;
            let noRedirectionPath = {
                name: "Postulate",
                params: {
                    slug,
                },
            };
            let redirectedPath = {
                name: "Redirecting",
                params: {
                    redirect: offer.redirect,
                    offerId: offer.id
                },
            };

            return offer.redirect ? redirectedPath : noRedirectionPath;
        },
        dateAvailable() {
            let [year, month, day] = this.offer.validity.end.split("-");
            let today = new Date();
            let end = new Date(year, parseInt(month) - 1, day, 23, 59, 59);
            console.log(today);
            console.log(end);
            return !(today > end);
        },
        getEndDate() {
            if (this.offer.validity.end && this.offer.validity.end.includes("-")) {
                const [year, month, day] = this.offer.validity.end.split("-");
                return `${day}/${month}/${year}`;
            }
            return this.offer.validity.end || "";
        },
        getStartDate() {
            let date = new Date(this.offer.moderatedAt);
            return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        },
        getStartToWorkDay() {
            if (this.offer.startAt && this.offer.startAt.includes("-")) {
                const [year, month, day] = this.offer.startAt.split("-");
                return `${day}/${month}/${year}`;
            }
            return this.offer.startAt || "";
        },
        professions() {
            return this.offer.professions.join(", ");
        },
        shareUrl() {
            const { slug, title } = this.offer;
            const url = `https://listado.trabajoconsentido.com/trabajos/${slug}`;
            const tags = "OfertaLaboral,PegasConSentido,TalentoSostenible,OportunidadLaboral,HayPega";
            const twitterText = `Te invitamos a revisar la oferta de ${title}.\nIngresa acá: `;
            const inlineText = `Te invitamos a revisar la oferta de ${title}. Ingresa acá: ${url}`;
            const emailText = `Te invitamos a revisar la oferta de ${title}.%0D%0AIngresa acá: ${url}`; // %0D%0A caracter de nueva línea 

            return {
                url,
                tags,
                facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&amp;src=sdkpreparse`,
                twitter: `https://twitter.com/intent/tweet?text=${twitterText}&hashtags=${tags}&url=${url}&via=pegasconsentido`,
                whatsapp: `https://api.whatsapp.com/send?text=${inlineText}`,
                linkedin: `https://www.linkedin.com/shareArticle?url=${url}`,
                email: `mailto:?subject=Postula a ${title}&body=${emailText}`,
            };
        },
    },

    created() {
        this.type = this.$store.getters["users/getType"];
        this.goalsToShow = this.offer.organization.goals.slice(0, 4);
    },

    methods: {
        onCopySocial() {
            let copyText = this.shareUrl.url;
            navigator.clipboard.writeText(copyText).then(() => {
                this.snackbar.text = "✔ Se copió la URL";
                this.snackbar.color = "success";
                this.snackbar.model = true;
            }, (err) =>  {
                this.snackbar.text = "❌ ¡Ups! No se pudo copiar la URL";
                this.snackbar.color = "error";
                this.snackbar.model = true;
            });
        },
        formatter(value) {
            const formatter = Intl.NumberFormat("es-CL", {
                currency: this.offer.salary.currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
            return formatter.format(value);
        },
    },
};
</script>

<style scoped>
.location {
  margin-bottom: 0;
}
.location > .icon {
  margin-left: 10px;
}
.event-header > .title {
  margin: 0;
}
.list-group {
  margin: 0;
  padding: 0;
  list-style: none;
}
.list-group > .list-item {
  padding: 1em 0;
  border-bottom: solid 1px #e5e5e5;
}
</style>
